import Vue from 'vue'
import VueTheMask from 'vue-the-mask'


export default () => {
  Vue.use(VueTheMask)
  return VueTheMask
}